import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FormControl } from '@mui/material';

import TextField from '@mui/material/TextField';
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Login from '@mui/icons-material/Login';
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_LINK } from "../API_BASE_PATH";
import { useGoogleLogin } from "@react-oauth/google";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});
const LoginPage = () => {
    const navigate = useNavigate();
    const [ValiDate, setValiDate] = useState('');
    const [GData, setGData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [LoginFormData, setLoginFormData] = useState({
        email: '',
        password: ''
    });

    const [values, setValues] = useState({
        showPassword: false,
    });
    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (localStorage.getItem("islogin") === 'true') {
            navigate(-1);

            // history.goBack();
        }
    }, []);




    const FinalLoginPayload = () => {
        // console.log(Object.keys(LoginFormData).length )
        let data;
        if (LoginFormData.email == '') {
            setValiDate('Please enter email address');
        } else if (LoginFormData.password == '') {
            setValiDate('Please enter password');
        } else {
            setValiDate('Login...');

            axios.post(`${API_BASE_LINK}users/login`, {
                "email_id": LoginFormData.email,
                "password": LoginFormData.password
            })
                .then(function (response) {
                    console.log(response);

                    // let loginSuccessData = {
                    //     loginStatus: response.status,
                    //     prefix: response.data.user.prefix,
                    //     F_name: response.data.user.first_name,
                    //     L_name: response.data.user.last_name,
                    //     mobile: response.data.user.mobile_number,
                    //     email: response.data.user.email_id,
                    // }
                    if (response.status === 200) {
                        localStorage.setItem('islogin', 'true');
                        // navigate("/");
                        localStorage.setItem('LoginUserDetails', JSON.stringify(response.data));
                        window.location.reload();
                    }
                })
                .catch(function (error) {
                    console.log(error.response.status);
                    if (error?.response?.status === 404) {
                        setValiDate('Invalid Username or Password')
                    } else if (error?.response?.status === 403) {
                        setValiDate('Phone number not verified')
                    } else {
                        setValiDate(error.response.message)
                    }
                });
        }

    }

    // const test = () => {
    //     navigate("/");
    // }

    const handleGoogleSuccess = async (tokenResponse) => {
        try {
            const { data: decoded } = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                headers: {
                    Authorization: `Bearer ${tokenResponse.access_token}`,
                },
            });
            console.log("Google User:", decoded);
            setGData(decoded);

        let federatedLoginBody = {
            "email_id": decoded?.email,
            "federated_id": btoa(decoded?.email),
            "google_jit": decoded?.jti,
            "first_name": decoded?.given_name,
            "last_name": decoded?.family_name,
        }

            const response = await axios.post(`${API_BASE_LINK}users/federatedLogin`, federatedLoginBody);
            console.log('----------------------', response);
            if (response?.status === 200) {
                localStorage.setItem('islogin', 'true');
                localStorage.setItem('LoginUserDetails', JSON.stringify(response?.data));
                navigate("/");
                window.location.reload();
            }
        } catch (error) {
            console.log(error?.response);
            setModalMessage(error?.response?.data?.error || 'An error occurred during login');
            setModalOpen(true);
        }
    };

    const googleLogin = useGoogleLogin({
        onSuccess: handleGoogleSuccess,
        onError: () => {
            setModalMessage('Google login failed. Please try again.');
            setModalOpen(true);
        },
    });

    const handleError = () => {
        console.log("Login Failed");
        setModalMessage('Google login failed. Please try again.');
        setModalOpen(true);
    };

    return (<>
        <main className='BOOKING_PAGE_MAIN_WRAP'>


            <div className="common_banner mb-2">
                <div className="container">
                    <div className="row">
                        <div className="col-auto">
                            <div className="iconBox"><span><img src="/img/ico13.svg" alt="" /></span></div>
                        </div>
                        <div className="col">
                            <h4>Login</h4>
                            <p className="mb-0">
                                This login is for navchr users.
                            </p>
                        </div>
                        {GData && <h1>{GData.email}</h1>}
                    </div>
                </div>
            </div>
            <div className="pt-4"></div>
            <section className="login_wraper">
                <div className="container">
                    <div className="row justify-content-center" >
                        <div className="col-lg-6">
                            <div className='login_inner'>
                                <div className="custBg">
                                    <div className="text-center mb-4">
                                        <h3>Welcome Back to  navChr</h3>
                                        <p>Login with Your Email id and Password</p>
                                    </div>
                                    <hr />
                                    <div className="pt-3"></div>
                                    <ThemeProvider theme={darkTheme}>
                                        {ValiDate !== '' && <div className="alert alert-danger" role="alert">
                                            <div>   {ValiDate}</div>
                                        </div>}
                                        <div className="row">
                                            <div className="col-md-12 mb-4">
                                                <div className="label">Email ID</div>
                                                <TextField
                                                    id="email_address"
                                                    variant="outlined"
                                                    className="w-100"
                                                    InputProps={{ sx: { height: '3rem' } }}
                                                    value={LoginFormData.email}
                                                    onChange={(e) => setLoginFormData({ ...LoginFormData, email: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-md-12 mb-4">

                                                <FormControl variant="outlined" className="w-100">
                                                    <div className="label">Password</div>
                                                    <OutlinedInput
                                                        // InputProps={{ sx: { height: '3rem' } }}
                                                        style={{ height: '3rem' }}
                                                        id="outlined-adornment-password"
                                                        type={values.showPassword ? 'text' : 'password'}
                                                        value={LoginFormData.password}
                                                        onChange={(e) => setLoginFormData({ ...LoginFormData, password: e.target.value })}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                >
                                                                    {values.showPassword ? <VisibilityOff /> : <Visibility />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }

                                                    />
                                                </FormControl>
                                            </div>

                                            <div className="col-12">
                                                <div className="row justify-content-between align-items-center">
                                                    <div className="col-4">
                                                        <div className="loginBtn">
                                                            <button className="btn cust_btn_one border-0 w-100" onClick={FinalLoginPayload}>
                                                                <Login /> &#160; Login
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        Forgot your
                                                        <Link to="/forgot-password"> <u>password</u> ?</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 text-center pt-4">
                                                <h6>------------- Or ------------</h6>
                                            </div>
                                            <div className='pt-4 w-100 loginwithgoogle  '>
                                                <button
                                                    type="button"
                                                    className="btn btn-light border d-flex align-items-center justify-content-center gap-2 w-100 py-3"
                                                    onClick={() => googleLogin()}
                                                >
                                                    <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" width="18" height="18" />
                                                    Sign in with Google
                                                </button>
                                            </div>
                                            <div className="col-12 text-center pt-5">
                                                <hr />
                                                <h6> Don’t have an account? <Link to='/register' className='btn cust_btn_one border-0'><u>Register now</u></Link></h6>
                                            </div>
                                        </div>

                                    </ThemeProvider>
                                </div>
                            </div>

                            <div>

                            </div>


                        </div>

                    </div>
                </div>
            </section>



        </main>
        <Dialog
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            sx={{
                '& .MuiBackdrop-root': {
                    backdropFilter: 'blur(4px)',
                },
            }}
        >
            <DialogTitle><h4 className='text-danger'><ErrorOutline /> Error</h4></DialogTitle>
            <DialogContent>
                <p>{modalMessage}</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setModalOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog></>
    )
};

export default LoginPage;

